import { Injectable, signal, WritableSignal } from '@angular/core';

export interface ConfirmOptions {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  private _visible = signal(false);
  private _title = signal('');
  private _message = signal('');
  private _confirmLabel = signal('Sí');
  private _cancelLabel = signal('Cancelar');

  private _currentResolver: ((value: boolean) => void) | null = null;

  readonly visible = this._visible;
  readonly title = this._title;
  readonly message = this._message;
  readonly confirmLabel = this._confirmLabel;
  readonly cancelLabel = this._cancelLabel;

  constructor() {}

  confirm(opts: ConfirmOptions): Promise<boolean> {
    if (this._visible()) return Promise.resolve(false);

    this._title.set(opts.title ?? '¿Estás seguro?');
    this._message.set(opts.message ?? '¿Deseas continuar con esta acción?');
    this._confirmLabel.set(opts.confirmLabel ?? 'Sí');
    this._cancelLabel.set(opts.cancelLabel ?? 'Cancelar');

    this._visible.set(true);

    return new Promise<boolean>((resolve) => {
      this._currentResolver = resolve;
    });
  }

  close(result: boolean) {
    if (this._currentResolver) {
      this._currentResolver(result);
      this._currentResolver = null;
    }
    this._visible.set(false);
  }
}
